import React, { Fragment } from 'react';

import Typography from '../../_ui/_blocks/Typography/Typography';
import Icon from '../../_ui/_blocks/Icon/Icon';

const ConsultationAssessmentOdonlyPoints = () => {
    const iconClassName = 'flex-shrink-0 md:w-[2rem] md:h-[2rem]';

    return (
        <Fragment>
            <li className="flex items-center gap-050">
                <Icon icon="profile-light" alt="Profile Icon" className={iconClassName} size="medium" loading="eager" />
                <Typography size="100" color="foundation">
                    Reviewed by our UK-based medical team
                </Typography>
            </li>
            <li className="flex items-center gap-050">
                <Icon icon="clock-light" alt="Clock icon" className={iconClassName} size="medium" loading="eager" />
                <Typography size="100" color="foundation">
                    Takes less than 3 minutes to complete
                </Typography>
            </li>
            <li className="flex items-center gap-050">
                <Icon icon="truck-light" alt="Truck icon" className={iconClassName} size="medium" loading="eager" />
                <Typography size="100" color="foundation">
                    Approved treatments dispatched same day <span className="whitespace-nowrap">(before 3pm)</span>
                </Typography>
            </li>
        </Fragment>
    );
};

export default ConsultationAssessmentOdonlyPoints;
